import React from 'react';

import { Marquee } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import { Footer, Meta } from '$partials/global';
import { SimpleImage } from '$partials/media';
import IconLogo from '$partials/icons/icon-logo.jsx';
import ModuleDispatcher from '$partials/modules/dispatcher.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HomePage}
 */
const HomePage = (props) => {
    const page = props.data.page;

    return (
        <>
            <Meta
                domain={props.domain}
                page={page}
                title='Ion Riva' />

            <main
                className='type-style-body'
                id='main-content'>
                {/* Header */}

                <header className='layout-container px-layout-outer pb-60 sm:pt-60'>
                    <h1 className='sr-only'>
                        {page.title}
                    </h1>

                    <div className='flex sm:block border-black pt-18'>
                        <div className='w-full flex gap-8 sm:gap-0 flex-col sm:flex-row'>
                            <div className='sm:w-6/12 md:w-4/12 sm:pr-30'>
                                <IconLogo className='w-[164px] h-[80px] sm:w-[329px] sm:h-[161px] mb-30 text-black' />

                                {page.headerMarqueeText &&
                                    <Marquee
                                        className='max-w-[539px] h-button-height rounded bg-yellow py-8 mb-8'
                                        id='header'>
                                        <div className='px-30 border-r border-black pt-[2px]'>
                                            {page.headerMarqueeText}
                                        </div>
                                    </Marquee>
                                }

                                {(page.headerCtaLabel && formatLinkBlockToUrl(page.headerCtaLink)) &&
                                    <a
                                        className='inline-flex basis-0 items-center sm:justify-center bg-yellow text-purple rounded px-10 sm:px-30 h-button-height min-w-[120px] hover:bg-purple hover:text-offwhite transition-colors'
                                        href={formatLinkBlockToUrl(page.headerCtaLink)}
                                        rel={page.headerCtaLink.linkTo === 'custom_url' ? 'noreferrer' : undefined}
                                        target={page.headerCtaLink.linkTo === 'custom_url' ? '_blank' : undefined}>
                                        {page.headerCtaLabel}
                                    </a>
                                }
                            </div>

                            <div className='sm:w-6/12 md:w-7/12 pl-3'>
                                <div className='relative aspect-square overflow-hidden rounded-[50%]'>
                                    {page.headerAsset && (
                                        <>
                                            {page.headerAsset?.image &&
                                                <SimpleImage
                                                    {...page.headerAsset.image}
                                                    className='w-full h-full object-cover' />
                                            }
                                            {page.headerAsset?.video &&
                                                <video
                                                    autoPlay={true}
                                                    className='w-full h-full object-cover pointer-events-none scale-[1.04]'
                                                    loop={true}
                                                    muted={true}
                                                    playsInline={true}
                                                    poster={page.headerAsset.video.poster}
                                                    src={page.headerAsset.video.src} />
                                            }
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {(page?.modules?.length > 0) &&
                    <div>
                        {page.modules.map((module, i) => (
                            <section
                                className='group/modulecontainer'
                                key={`${i}-${module?.id}`}>
                                <ModuleDispatcher
                                    {...module} />
                            </section>
                        ))}
                    </div>
                }
            </main>

            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HomePage;
